export interface IThumbnailApiClient {
    getThumbnail(
        resourceId: string,
        size: string,
        options?: { originalHostname?: string; accessToken?: string }
    ): Promise<any>;
}

export class ThumbnailApiClient implements IThumbnailApiClient {
    baseUrl: string;
    constructor(baseUrl: string = '') {
        this.baseUrl = baseUrl;
    }

    private getHeaders(
        h: {
            [key: string]: string;
        },
        options?: { accessToken?: string }
    ) {
        const headers: {
            [key: string]: string;
        } = {};

        if (typeof options?.accessToken === 'string' && options.accessToken.length > 0) {
            headers.Authorization = `bearer ${options.accessToken}`;
        }

        return { ...headers, ...h };
    }

    async getThumbnail(
        resourceId: string,
        size: string,
        options?: { originalHostname?: string; accessToken?: string },
        isPublicRefComponent?: boolean
    ) {
        const url = `${
            this.baseUrl || ''
        }/api/admin/thumbnail?resourceId=${encodeURIComponent(resourceId)}&size=${size}.png&isPublicRefComponent=${isPublicRefComponent || false}`;
        const res = await fetch(url, {
            method: 'GET',
            headers: this.getHeaders(
                {
                    'Content-Type': 'image/png',
                },
                options
            ),
        });

        // Check if response is successful before trying to create blob
        if (!res.ok) {
            return null;
        }

        const imageBlob: any = await res.blob();
        if (imageBlob && imageBlob.size > 0) {
            const imageObjectURL = URL.createObjectURL(imageBlob);
            return imageObjectURL;
        } else {
            return null;
        }
    }
}
